// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

export const StyledLabel = styled(Box)(({ theme, ownerState }) => {
  const isLight = theme.palette.mode === 'light';

  const filledVariant = ownerState.variant === 'filled';

  const outlinedVariant = ownerState.variant === 'outlined';

  const softVariant = ownerState.variant === 'soft';

  const defaultStyle = {
    ...theme.typography.body1,
    ...(ownerState.color === 'default' && {
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: theme.palette.background.disabled,
        color: theme.palette.grey[600],
        border: `1px solid ${theme.palette.grey[600]}`,
      }),
      // SOFT
      ...(softVariant && {
        color: theme.palette.text.primary,
        backgroundColor: alpha(theme.palette.grey[500], 0.16),
      }),
    }),
  };

  const colorStyle = {
    ...theme.typography.body1,
    ...(ownerState.color !== 'default' && {
      // FILLED
      ...(filledVariant && {
        color: theme.palette[ownerState.color].contrastText,
        backgroundColor: theme.palette[ownerState.color].main,
      }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: 'transparent',
        color: theme.palette[ownerState.color].main,
        border: `1px solid ${theme.palette[ownerState.color].main}`,
      }),
      // SOFT
      ...(softVariant && {
        color: theme.palette[ownerState.color][isLight ? 'dark' : 'light'],
        backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
      }),
    }),

    ...(ownerState.color === 'primary' && {
      // FILLED
      ...(filledVariant && {
        color: theme.palette[ownerState.color].contrastText,
        backgroundColor: theme.palette[ownerState.color].main,
      }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor: theme.palette.color.primaryHoverBackground,
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
      }),
      // SOFT
      ...(softVariant && {
        color: theme.palette[ownerState.color].main,
        backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
      }),
    }),

    ...(ownerState.color === 'success' && {
      // FILLED
      // ...(filledVariant && {
      //   color: theme.palette[ownerState.color].contrastText,
      //   backgroundColor: theme.palette[ownerState.color].main,
      // }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor:  theme.palette[ownerState.color].lighter,
        color: theme.palette[ownerState.color].main,
        border: `1px solid ${theme.palette[ownerState.color].main}`,
      }),
      // SOFT
      // ...(softVariant && {
      //   color: theme.palette[ownerState.color][isLight ? 'dark' : 'light'],
      //   backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
      // }),
    }),

    ...(ownerState.color === 'warning' && {
      // FILLED
      // ...(filledVariant && {
      //   color: theme.palette[ownerState.color].contrastText,
      //   backgroundColor: theme.palette[ownerState.color].main,
      // }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor:  theme.palette[ownerState.color].lighter,
      }),
      // SOFT
      // ...(softVariant && {
      //   color: theme.palette[ownerState.color][isLight ? 'dark' : 'light'],
      //   backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
      // }),
    }),

    ...(ownerState.color === 'error' && {
      // FILLED
      ...(filledVariant && {
        color: theme.palette[ownerState.color].contrastText,
        backgroundColor: theme.palette[ownerState.color].main,
      }),
      // OUTLINED
      ...(outlinedVariant && {
        backgroundColor:  theme.palette[ownerState.color].lighter,
        color: theme.palette[ownerState.color].main,
        border: `1px solid ${theme.palette[ownerState.color].main}`,
      }),
      // SOFT
      ...(softVariant && {
        color: theme.palette[ownerState.color][isLight ? 'dark' : 'light'],
        backgroundColor: alpha(theme.palette[ownerState.color].main, 0.16),
      }),
    })
  };

  return {
    height: 30,
    minWidth: 22,
    lineHeight: 0,
    borderRadius: 2,
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    textTransform: 'capitalize',
    padding: theme.spacing(0, 1),
    color: theme.palette.grey[800],
    fontSize: theme.typography.pxToRem(12),
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.grey[300],
    fontWeight: theme.typography.fontWeightBold,
    ...colorStyle,
    ...defaultStyle,
  };
});
